<div class="home-redesign" #homeRoot>
  <app-home-presentation-section
    [presentationSlides]="presentationSlides"
    [presentationHero]="presentationHero"
    [activePresentationIndex]="activePresentationIndex"
    [heroTrackerRotateX]="heroTrackerRotateX"
    [heroTrackerRotateY]="heroTrackerRotateY"
    [heroTrackerOffsetX]="heroTrackerOffsetX"
    [heroTrackerOffsetY]="heroTrackerOffsetY"
    [heroTrackerGlowX]="heroTrackerGlowX"
    [heroTrackerGlowY]="heroTrackerGlowY"
    [presentationStepLabel]="presentationStepLabel"
    (presentationSlideRequested)="goToPresentationSlide($event)"
    (heroTrackerMove)="onHeroTrackerMove($event)"
    (heroTrackerLeave)="resetHeroTracker()"
  ></app-home-presentation-section>

  <section class="home-slider-fade-bridge" aria-hidden="true"></section>

  <app-home-trust-carousel-section [clientLogos]="clientLogos"></app-home-trust-carousel-section>

  <app-home-metrics-section
    [stats]="stats"
    [currentValues]="currentValues"
  ></app-home-metrics-section>

  <app-home-approach-section [approachSteps]="approachSteps"></app-home-approach-section>

  <app-home-testimonial-section></app-home-testimonial-section>

  <app-home-services-showcase-section></app-home-services-showcase-section>

  <app-home-portfolio-section [portfolioCases]="featuredPortfolioCases"></app-home-portfolio-section>

  <app-home-final-cta-section [calendlyPlaceholderUrl]="calendlyPlaceholderUrl"></app-home-final-cta-section>
</div>
